// MAYBE DELETE
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Page } from "@digital-services/shell";
import { Typography } from "@digital-services/ui";

export const UnAuthorizedPage: FunctionComponent = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "account" });
  return (
    <Page title="UnAuthorized">
      <Typography variant="sectionTitle">
        {t("signin.unauthorized.message")}
      </Typography>
    </Page>
  );
};
